import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { TypeImageService } from '../type-image.service';
import { NotificationService } from 'src/app/services/notification.service';
import { AuthService } from 'src/app/services/auth.service';
import { finalize } from 'rxjs';
import { helper } from 'src/environments/helper';

@Component({
    selector: 'app-edit-type-image',
    templateUrl: './edit-type-image.component.html',
    styleUrls: ['./edit-type-image.component.scss'],
})
export class EditTypeImageComponent {
    // general error
    errorTitle: string = environment.config.customNotifications.headers.error;
    errorIcon: string = environment.config.customNotifications.icons.error;
    errorType: string = environment.config.customNotifications.icons.error;

    helper = helper;
    isLoading = false;

    form: FormGroup = new FormGroup({
        name: new FormControl(this.data.name, Validators.required),
        width: new FormControl(this.data.width, Validators.required),
        height: new FormControl(this.data.height, Validators.required),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: any,
        private dialogRef: MatDialogRef<EditTypeImageComponent>,
        private typeImageService: TypeImageService,
        private notificationService: NotificationService,
        private authService: AuthService
    ) { }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    submitForm() {
        this.isLoading = true;

        const updatedImageType = {
            name: this.form.get('name')?.value,
            width: this.form.get('width')?.value,
            height: this.form.get('height')?.value,
            id: this.data.id,
        };

        this.typeImageService
            .updateImageType(updatedImageType)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: () => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
